import { Link, useLocation } from "@remix-run/react";
import { Button } from "~/components/ui/button";
import { ThemeToggle } from "~/components/ThemeToggle";
import { HamburgerMenu } from "~/components/HamburgerMenu";
import { FeedbackPopover } from "~/components/FeedbackPopover";
import { IconAppWindow } from "@tabler/icons-react";
import { technologies } from "~/utils/technologies";
import { cn } from "~/lib/utils";

export function Header() {
  const location = useLocation();
  const currentPath = location.pathname.split("/")[1];

  const isActive = (path: string) => currentPath === path;

  const linkClass = (path: string) =>
    `text-sm font-medium ${isActive(path) ? "underline" : "hover:underline"}`;

  return (
    <header className="border-b">
      <nav className="container mx-auto px-4 md:px-12 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="text-xl font-bold flex items-center gap-2 flex-nowrap text-nowrap"
        >
          <IconAppWindow /> Best of Web
        </Link>
        <div className="hidden md:flex space-x-6">
          {technologies.map((tech, index) => (
            <Link key={tech.name} to={`/cat/${tech.name}/all`} className={cn(linkClass(tech.name), index > 4 && "max-lg:hidden")}>
              {tech.formattedName}
            </Link>
          ))}
        </div>
        <div className="flex items-center space-x-4">
          <FeedbackPopover placement="header">
            <Button variant="outline">Feedback</Button>
          </FeedbackPopover>
          <ThemeToggle className="max-md:hidden" />
          <HamburgerMenu />
        </div>
      </nav>
    </header>
  );
}
